import { Alert, Button, Chip, CircularProgress, Container } from "@mui/material";
import Box from "@mui/material/Box";
import React, { useCallback, useEffect, useState } from "react";
import { ASSET_MAINTENANCE_TYPE_URL } from "../../Constants/Constants";
import AxiosInstance from "../../services/AxiosInstance";
import AppTableView from "../AppTableView";
import { useAlert } from "../alerts/AlertContext";
import AssetMaintenanceTypeDialog from "./AssetMaintenanceTypeDialog";


function AssetMaintenanceType() {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const showAlert = useAlert();

    const getAssetMaintenanceTypeData = useCallback(async () => {
        setLoading(true);
        setError(null);
        try {
            const response = await AxiosInstance.get(`${ASSET_MAINTENANCE_TYPE_URL}`);
            setData(response.data || []);
        } catch (error) {
            console.error("Error fetching Asset Maintenance type data:", error);
            setError("Failed to load Asset Maintenance type data. Please try again.");
            // showAlert("Failed to load statuses", "error");
        } finally {
            setLoading(false);
        }
    }, [showAlert]);

    useEffect(() => {
        getAssetMaintenanceTypeData();
    }, [getAssetMaintenanceTypeData]);

    const columns = [
        {
            field: "id",
            flex: 1,
            headerName: "Id",
            renderCell: (params) => params.value,
        },
        {
            field: "name",
            flex: 2,
            headerName: "Name",
            renderCell: (params) => params.value,
        },
        {
            field: "enabled",
            flex: 1,
            headerName: "Enabled",
            renderCell: (params) => params.value?"YES":"NO",
        },
        {
            field: "description",
            flex: 1,
            headerName: "Description",
            renderCell: (params) => params.value,
        },
        {
            field: "action",
            flex: 1,
            headerName: "Actions",
            disableColumnMenu: true,
            sortable: false,
            renderCell: (params) => (
                <Box sx={{ display: "flex", gap: 1, alignItems: "center" }}>
                    <AssetMaintenanceTypeDialog
                        assetMaintenanceTypeId={params.row.id}
                        assetMaintenanceTypeName="Edit"
                        variant="link"
                    />
                </Box>
            ),
        },
    ];

    //if error content
    if (error) {
        return (
            <Container>
                <Alert
                    severity="error"
                    action={
                        <Button color="inherit" size="small" onClick={getAssetMaintenanceTypeData}>
                            Retry
                        </Button>
                    }
                    sx={{ borderRadius: 2 }}
                >
                    {error}
                </Alert>
            </Container>
        );
    }

    return (
        <Box
            sx={{
                borderRadius: "8px",
                overflow: "hidden",
                p: 2,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "100%",
            }}
        >
            {/* loading or content */}
            {loading ? (
                <Box
                    sx={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        height: "100%",
                    }}
                >
                    <CircularProgress />
                </Box>
            ) : (
                <AppTableView rows={data} cols={columns} initialPageSize={5} />
            )}
        </Box>
    );
}

export default AssetMaintenanceType;
